import request from '@/utils/request'

export function getPageList(data) {
  return request({
    url: 'appoint/getPageList',
    method: 'post',
    data,
  })
}

export function save(data) {
  return request({
    url: 'appoint/Save',
    method: 'post',
    data,
  })
}
